import { cx } from '@linaria/core';
import { mdiCrown, mdiCrownOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { IconProps } from '.';
import { locales } from '../../locales/en';
import "./CrownOutline.linaria.module.css!=!./CrownOutline?./CrownOutline.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNTy+Mz0wpSEs30UPhVecmFqVn5ukm5ZeU5OdaGVjXcgEAa7kIUi8AAAA="
const bottomMargin = "atm_gq_idpfg4";
const Crown = (props: IconProps) => {
  const {
    filled = false,
    size = 1,
    className,
    ...other
  } = props;
  return <Icon path={filled ? mdiCrown : mdiCrownOutline} title={locales.settings.pinToTop.priorWinnersTooltip} size={size} {...other} className={cx(bottomMargin, className)} />;
};
export default Crown;